import { ChangeDetectorRef, Input } from '@angular/core';
import { EventEmitter, Output, ViewChild } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { DevicePilomat } from 'src/app/model/devicePilomat';
import { LogEvent } from 'src/app/model/logEvent';
import { DeviceService } from 'src/app/service/device.service';
import { UserService } from 'src/app/service/user.service';
import { Log } from 'src/app/util/log';

@Component({
  selector: 'app-devices-list',
  templateUrl: './devices-list.component.html',
  styleUrls: ['./devices-list.component.css']
})
export class DevicesListComponent implements OnInit {

  @ViewChild('deviceslisttable', { static: true }) table;
  // @ViewChild('deviceslistloader', { static: true }) loader;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Output() selected = new EventEmitter<DevicePilomat>();
  @Input() filter: string;
  @Input() deviceList: DevicePilomat[];

  devicesReceived: boolean = false;

  selectedDevice: DevicePilomat;
  selectedRow: number;

  // devicesList: DevicePilomat[];
  dataSource: MatTableDataSource<DevicePilomat>;

  displayedColumns: string[] = ['name' , 'serial' , 'stateIcon', 'stateDescription', 'city', 'address'];

  constructor(
    private deviceService: DeviceService,
    private userService: UserService,
    private cdRef: ChangeDetectorRef) {

  }

  ngOnInit() {
    if(this.isAdmin() || this.isService()){
      this.displayedColumns = ['name' , 'serial', 'fwVersion' , 'stateIcon', 'stateDescription', 'city', 'address'];
    }
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.loader.showLoading();
    // });

    // this.getDeviceList();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.deviceList) {
      if (this.deviceList.length > 0 && !this.devicesReceived) {
        this.devicesReceived = true;
        this.updateTable();
      }
      this.table.dataSource.filter = this.filter.trim().toLowerCase();
    }
  }

  public isAdmin(): boolean {
    return this.userService.isAdmin;
  }

  public isService(): boolean {
    return this.userService.isService;
  }

  updateTable() {
    this.table.dataSource = new MatTableDataSource(this.deviceList);
    this.table.dataSource.sort = this.sort;
    this.table.dataSource.filterPredicate = this.filterTable;
  }

  // getDeviceList() {

  //   Log.debug("getDeviceList");

  //   this.loader.showLoading();

  //   const obs = this.deviceService.getDevices();
  //   obs.subscribe(data => {

  //     this.devicesList = data;

  //     this.table.dataSource = new MatTableDataSource(this.devicesList);
  //     this.table.dataSource.sort = this.sort;
  //     this.table.dataSource.filterPredicate = this.filterTable;

  //     this.loader.hideLoading();

  //   }, error => {

  //     // this.loader.hideLoading();
  //     // this.loader.showError();
  //   });
  // }


  filterTable(data: DevicePilomat, filter: string): boolean {


    if (data.name && data.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.systemInfo.address && data.systemInfo.address.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.systemInfo.city && data.systemInfo.city.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.serial && data.serial.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.stateString && data.stateString.trim().toLowerCase().startsWith(filter)) {
      return true;
    }

    return false;
  }


  onRowClicked(row) {

    Log.debug('clicked device with id ' + row.id);

    this.selectedRow = row.id;

    this.selected.emit(row);
    this.selectedDevice = row;

    this.cdRef.detectChanges();
  }
}


